import { useParams } from 'react-router-dom';
import BlogPostCard from '../components/BlogPostCard';
import FeaturedPost from '../components/FeaturedPost';
import { getAllPosts, getPostsByTag } from '../data/posts';
import styles from '../styles/Blog.module.css';

function Blog() {
    const { tag } = useParams<{ tag?: string }>();
    const allPosts = tag ? getPostsByTag(tag) : getAllPosts();
    const featuredPost = allPosts.length > 0 && !tag ? allPosts[0] : null;
    const otherPosts = featuredPost ? allPosts.slice(1) : allPosts;

    return (
        <div className={styles.blog}>
            <section className={styles.hero}>
                <h1>{tag ? `Posts tagged with "${tag}"` : 'Blog'}</h1>
                <p>
                    {tag
                        ? `Showing ${allPosts.length} post${allPosts.length !== 1 ? 's' : ''}`
                        : 'Technical insights, tutorials, and thoughts on software engineering'}
                </p>
            </section>

            {featuredPost && (
                <section className={styles.featured}>
                    <h2 className={styles.sectionTitle}>Featured Post</h2>
                    <FeaturedPost post={featuredPost} />
                </section>
            )}

            {otherPosts.length > 0 && (
                <section className={styles.recentPosts}>
                    <h2 className={styles.sectionTitle}>{tag ? 'Posts' : 'Recent Posts'}</h2>
                    <div className={styles.postGrid}>
                        {otherPosts.map((post) => (
                            <BlogPostCard key={post.slug} post={post} />
                        ))}
                    </div>
                </section>
            )}

            {otherPosts.length === 0 && featuredPost && (
                <section className={styles.stayTuned}>
                    <p>More posts coming soon. Stay tuned.</p>
                </section>
            )}

            {allPosts.length === 0 && (
                <p className={styles.noPosts}>
                    {tag
                        ? `No posts found with tag "${tag}".`
                        : 'No blog posts yet. Check back soon!'}
                </p>
            )}
        </div>
    );
}

export default Blog;
